import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const SelectBrushIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M2.77999 15.5C2.68999 15.1 2.28999 14.84 1.87999 14.94C1.47999 15.03 1.21999 15.43 1.31999 15.84C1.56999 16.92 1.87999 17.88 2.25999 18.7C2.42999 19.08 2.87999 19.24 3.25999 19.06C3.63999 18.89 3.79999 18.44 3.61999 18.06C3.28999 17.35 2.99999 16.47 2.77999 15.5Z"
        fill={color}
      />
      <path
        d="M3.43 2.50999C2.77 3.16999 2.22 4.02999 1.79 5.06999C1.63 5.44999 1.82 5.88999 2.2 6.04999C2.58 6.20999 3.02 6.01999 3.18 5.63999C3.53 4.78999 3.97 4.08999 4.55 3.50999C4.85 3.21999 4.85 2.73999 4.56 2.44999C4.24 2.11999 3.72 2.16999 3.43 2.50999Z"
        fill={color}
      />
      <path
        d="M8.41 21.2C7.44 20.97 6.56 20.68 5.86001 20.34C5.49001 20.16 5.04001 20.32 4.86001 20.69C4.68001 21.06 4.84 21.51 5.21 21.69C6.02 22.08 6.98001 22.4 8.06001 22.65C8.46001 22.74 8.87 22.49 8.96 22.09C9.05 21.69 8.8 21.28 8.4 21.19L8.41 21.2Z"
        fill={color}
      />
      <path
        d="M2.29999 11.87C2.25999 10.96 2.27998 10.01 2.36998 9.11999C2.40998 8.70999 2.10999 8.33999 1.69999 8.29999C1.28999 8.25999 0.919985 8.56 0.879985 8.97C0.779985 9.92 0.759985 10.95 0.799985 11.93C0.819985 12.34 1.16999 12.67 1.57999 12.65C1.98999 12.63 2.31999 12.28 2.29999 11.87Z"
        fill={color}
      />
      <path
        d="M7.44 2.15999C8.2 2.11999 9.02 2.27999 9.9 2.63999C10.28 2.78999 10.72 2.60999 10.88 2.21999C11.03 1.83999 10.85 1.39999 10.46 1.23999C9.37 0.799992 8.33 0.609992 7.36 0.659992C6.95 0.679992 6.63 1.02999 6.65 1.44999C6.67 1.86999 7.02 2.17999 7.44 2.15999Z"
        fill={color}
      />
      <path
        d="M23.34 16.34C23.34 15.47 23.15 14.55 22.77 13.59C22.62 13.2 22.18 13.01 21.8 13.17C21.41 13.32 21.22 13.76 21.38 14.14C21.69 14.92 21.84 15.66 21.84 16.34C21.76 16.81 21.98 17.38 22.53 17.4C23.12 17.46 23.41 16.84 23.34 16.34Z"
        fill={color}
      />
      <path
        d="M20.43 19.51C19.89 20.05 19.17 20.5 18.28 20.85C17.89 21 17.7 21.43 17.86 21.81C18 22.2 18.45 22.4 18.84 22.24C19.92 21.81 20.81 21.25 21.51 20.55C21.81 20.25 21.8 19.76 21.48 19.48C21.18 19.2 20.71 19.21 20.43 19.51Z"
        fill={color}
      />
      <path
        d="M14.79 21.63C13.91 21.71 12.97 21.73 12.04 21.69C11.63 21.67 11.28 21.99 11.26 22.4C11.24 22.82 11.56 23.17 11.98 23.19C12.98 23.24 13.96 23.22 14.94 23.12C15.35 23.08 15.65 22.71 15.62 22.3C15.58 21.89 15.22 21.59 14.8 21.62L14.79 21.63Z"
        fill={color}
      />
      <path
        d="M19.57 11.04C20.14 11.83 21.37 10.91 20.77 10.14C20.3 9.51001 19.74 8.85001 19.13 8.17001C20.22 6.84001 21.47 5.23001 22.59 3.44001C22.98 2.86001 22.92 2.12001 22.45 1.65001C21.98 1.18001 21.24 1.12001 20.68 1.50001C18.89 2.62001 17.28 3.87001 15.94 4.97001C15.24 4.34001 14.56 3.76001 13.91 3.27001C13.58 3.02001 13.11 3.09001 12.86 3.42001C12.61 3.75001 12.68 4.22001 13.01 4.47001C13.57 4.89001 14.17 5.40001 14.78 5.94001C13.16 7.35001 11.43 8.59001 10.49 10.73C10.24 10.71 9.98999 10.73 9.74999 10.77C8.72999 10.95 7.88999 11.65 7.39999 12.72C7.25999 13.03 7.15999 13.39 7.03999 13.82C6.75999 14.8 6.37999 16.14 5.30999 17.55C5.09999 17.82 5.09999 18.21 5.32999 18.48C5.47999 18.66 5.69999 18.75 5.92999 18.75H5.95999C6.50999 18.75 10.41 18.66 12.51 16.15C13.12 15.42 13.39 14.51 13.35 13.63C15.51 12.69 16.75 10.95 18.17 9.33001C18.69 9.92001 19.18 10.5 19.58 11.04H19.57ZM11.35 15.19C10.31 16.44 8.58999 16.93 7.36999 17.13C7.98999 16 8.26999 14.98 8.48999 14.23C8.58999 13.86 8.67999 13.55 8.77999 13.35C9.06999 12.73 9.49999 12.34 10.03 12.25C10.12 12.23 10.21 12.23 10.3 12.23C10.77 12.23 11.2 12.44 11.44 12.68C12.1 13.34 11.93 14.51 11.36 15.2L11.35 15.19ZM16.41 9.05001C15.35 10.31 14.34 11.5 12.91 12.17C12.79 11.97 12.65 11.77 12.48 11.6C12.31 11.43 12.12 11.29 11.92 11.17C12.59 9.75001 13.78 8.74001 15.04 7.68001C15.4 7.38001 15.75 7.08001 16.08 6.78001C17.39 5.68001 19.12 4.28001 21.07 3.01001C19.81 4.95001 18.41 6.68001 17.32 7.98001C17.01 8.33001 16.71 8.68001 16.41 9.04001V9.05001Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SelectBrushIcon.displayName = 'SelectBrushIcon';
